import moment from "moment";

export const getRowClassName = (record: any, index: any) => {
  if (index % 2 === 0) {
    return "even-row";
  } else {
    return "odd-row";
  }
};
export const components = {
  header: {
    wrapper: (props: any) => <thead className="custom-header" {...props} />,
    row: (props: any) => <tr className="custom-header-row" {...props} />,
    cell: (props: any) => <th className="ant-table-cell" {...props} />,
  },
};

export function DOBFormat(date: any) {
  return date ? moment(date).format("DD/MM/YYYY") : "";
}

export function formattedTimeRange(time: any) {
  return time ? time
    .split('-') // Split the range into start and end times
    .map((time: any) => time.replace(/:\d{2}(?=\s?[ap]m)/i, '')) // Remove the seconds part
    .join('-') : ''
}

export const determineShift = (timeRange: any) => {

  const startTime = timeRange.split('-')[0].trim();


  const [time, meridian] = startTime.split(' ');
  const [hour, minute] = time.split(':').map(Number);

  let hoursIn24 = hour;
  if (meridian?.toLowerCase() === 'pm' && hour !== 12) {
    hoursIn24 += 12;
  } else if (meridian?.toLowerCase() === 'am' && hour === 12) {
    hoursIn24 = 0;
  }

  // Determine the shift
  if (hoursIn24 >= 5 && hoursIn24 < 12) {
    return "Morning";
  } else if (hoursIn24 >= 12 && hoursIn24 < 17) {
    return "Afternoon";
  } else if (hoursIn24 >= 17 && hoursIn24 < 21) {
    return "Evening";
  } else {
    return "Night";
  }
};

export function GetPermission() {

  const permission: any = localStorage.getItem("permission");

  // const parsePermission = JSON.parse(permission)

  if (permission) {
    return permission;
  }

  return null;
}




export function GetLoggedInUser() {
  const user = localStorage.getItem("userProfile");
  return user ? JSON.parse(user) : null;
}

export function isSuperAdmin() {
  const user = GetLoggedInUser();
  return user?.roleId === 1; // Assuming 1 is Super Admin
}

export const NO_PERMISSION_MESSAGE = "You don't have permission to access this.Please contact your administrator.";